// extracted by mini-css-extract-plugin
export var article = "EventPageTemplate-module--article--60b0f";
export var category = "EventPageTemplate-module--category--cd6ca";
export var date = "EventPageTemplate-module--date--ba14b";
export var description = "EventPageTemplate-module--description--ee66a";
export var futureBanner = "EventPageTemplate-module--futureBanner--433b8";
export var grid = "EventPageTemplate-module--grid--cc9e7";
export var headerSectionTitle = "EventPageTemplate-module--headerSectionTitle--5bf29";
export var hubspot = "EventPageTemplate-module--hubspot--61e72";
export var localTimeHint = "EventPageTemplate-module--localTimeHint--57560";
export var location = "EventPageTemplate-module--location--d2fb5";
export var meta = "EventPageTemplate-module--meta--57287";
export var metaItem = "EventPageTemplate-module--metaItem--ce60c";
export var pastHeaderSection = "EventPageTemplate-module--pastHeaderSection--ec6c0";
export var presenters = "EventPageTemplate-module--presenters--4f1da";
export var presentersLabel = "EventPageTemplate-module--presentersLabel--ce918";
export var presentersOnDark = "EventPageTemplate-module--presentersOnDark--48015";
export var subtitle = "EventPageTemplate-module--subtitle--11924";
export var thumbnail = "EventPageTemplate-module--thumbnail--63abb";
export var title = "EventPageTemplate-module--title--45e84";